import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";

// Testo legale/privacy fisso (piattaforma amatoriale, conformità GDPR base).
// `children` è l'elemento cliccabile che apre la modale (es. un link/button).
export function LegalModal({ children }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        data-testid="legal-modal"
        className="max-w-lg max-h-[85vh] overflow-y-auto bg-[#12161A] border-white/10 text-[#E2E8F0]"
      >
        <DialogHeader>
          <DialogTitle className="text-lg font-extrabold text-[#F59E0B]">
            Informativa Privacy e Termini di Utilizzo (Amatoriale)
          </DialogTitle>
          <DialogDescription className="text-xs text-[#94A3B8]">
            Piattaforma amatoriale a scopo ricreativo — informativa sui dati e limitazione di responsabilità.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 text-sm leading-relaxed">
          <section>
            <h3 className="font-extrabold text-white mb-1">1. Trattamento dei Dati (Privacy)</h3>
            <p className="text-[#CBD5E1]">
              Questo sito è una piattaforma amatoriale creata a scopo ricreativo tra amici. Non
              vengono richiesti dati personali identificativi diretti (come nome, cognome o email).
              La registrazione avviene esclusivamente tramite codice d'invito e password
              personalizzata.
            </p>
            <p className="text-[#CBD5E1] mt-2">
              I sistemi informatici raccolgono unicamente i dati tecnici necessari al funzionamento
              dell'applicazione (es. indirizzo IP, log di sessione e cookie tecnici per mantenere
              l'accesso). Tali dati non vengono ceduti a terzi, non vengono usati per scopi
              commerciali e sono protetti adottando misure di sicurezza standard.
            </p>
          </section>

          <section>
            <h3 className="font-extrabold text-white mb-1">2. Limitazione di Responsabilità (Disclaimer)</h3>
            <p className="text-[#CBD5E1]">
              L'applicazione è fornita "così com'è", senza alcuna garanzia di funzionamento
              ininterrotto. L'amministratore della piattaforma è unicamente un gestore tecnico e non
              si assume alcuna responsabilità per:
            </p>
            <ul className="mt-2 space-y-1.5 text-[#CBD5E1]">
              <li className="flex gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#F59E0B]" />
                <span>Errori di calcolo dei punteggi, dei calendari o della lista calciatori di Serie A.</span>
              </li>
              <li className="flex gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#F59E0B]" />
                <span>Perdita accidentale di dati, punteggi o profili utente.</span>
              </li>
              <li className="flex gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#F59E0B]" />
                <span>
                  Eventuali dispute, scommesse o accordi privati economici tra i partecipanti (il
                  gioco non prevede, né promuove, alcuna forma di gioco d'azzardo o premi in
                  denaro).
                </span>
              </li>
            </ul>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  );
}
